import {ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject, catchError, EMPTY, Subject, takeUntil} from "rxjs";
import {filter, map} from "rxjs/operators";
import { HttpErrorResponse } from "@angular/common/http";
import {SharedService} from "@shared/shared.service";
import {AssociationsService} from "@shared/services/associations.service";
import {AssociationListResponse} from "@services/back-office/model/associationListResponse";
import {TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";
import {OrganizationTariffModel} from "@services/back-office/model/organizationTariffModel";
import {MatTableDataSource} from '@angular/material/table';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-association-tariff-history',
    templateUrl: './association-tariff-history.component.html',
    styleUrls: ['./association-tariff-history.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AssociationTariffHistoryComponent implements OnInit, OnDestroy {
    /** Loading */
    loading$ = new BehaviorSubject(false);
    tariffDataSource: MatTableDataSource<OrganizationTariffModel> = new MatTableDataSource<OrganizationTariffModel>();
    tariffColumns: string[] = ['createdAt', 'author', 'tariff'];
    /** Subject to destroy Subscriptions */
    private destroyed$ = new Subject<void>();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            association: AssociationListResponse
        },
        private associationsService: AssociationsService,
        private dialogRef: MatDialogRef<AssociationTariffHistoryComponent>,
        private translateService: TranslateService,
        private toastrService: ToastrService
    ) {
    }

    ngOnInit(): void {
        this.loading$.next(true);
        this.associationsService.loadTariffs(this.data.association.id!).pipe(
            takeUntil(this.destroyed$),
            filter(data => !!data),
            map((result: OrganizationTariffModel[]) => {
                this.tariffDataSource.data = result;
                this.loading$.next(false);
            }),
            catchError((error: HttpErrorResponse) => {
                SharedService.showErrorWithTitle(
                    this.translateService,
                    this.toastrService,
                    `responseErrors.${error.message}`
                );
                this.loading$.next(false);
                return EMPTY;
            })
        ).subscribe();
    }

    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
        this.loading$.complete();
    }

    closeDialog(result: boolean, data?: any) {
        this.dialogRef.close({result, data});
    }

}
